import { useApolloClient } from "@apollo/client";
import { MenuItemWithIcon } from "@msys/ui";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import { useTranslate } from "@tolgee/react";
import { useSnackbar } from "notistack";
import React from "react";
import { useTemplateRecomputeExpressionDependencyGraphMutation } from "./TemplateRecomputeExpressionDependencyGraphButton.generated.js";

interface Props {
  docId: string;
  refetchQueries?: string[];
}

export function TemplateRecomputeExpressionDependencyGraphButton({
  docId,
  refetchQueries,
}: Props) {
  const { t } = useTranslate("Quote");

  const { enqueueSnackbar } = useSnackbar();

  const client = useApolloClient();

  const [recomputeExpressionDependencyGraph, { loading }] =
    useTemplateRecomputeExpressionDependencyGraphMutation({
      client,
      refetchQueries,
    });

  return (
    <MenuItemWithIcon
      icon={<ScatterPlotIcon />}
      onClick={async () => {
        try {
          await recomputeExpressionDependencyGraph({
            variables: {
              input: {
                docId: docId,
              },
            },
          });
        } catch (error) {
          if (error instanceof Error)
            enqueueSnackbar(error.message, {
              variant: "error",
            });
        }
      }}
      disabled={loading}
    >
      {t("Recompute expressions", { ns: "Quote" })}
    </MenuItemWithIcon>
  );
}
